import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Image
import ModalImage from "react-modal-image";

// Navigation
import { useNavigate, useParams, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import LoginForm from '../../components/LoginForm';

@inject('AuthStore', 'PaymentNotificationStore')
@observer

class PaymentNotificationDetails extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        if (this.props.PaymentNotificationStore.paymentNotificationDatas[this.props.id] === undefined) {
            Helpers.getPaymentNotification(this.props.id)
        }
    }

    render() {
        const details = this.props.PaymentNotificationStore.paymentNotificationDatas[this.props.id];

        const storeId = localStorage.getItem('storeId');

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('details')}
                    visibleCategories={false}
                >
                    {
                        this.props.AuthStore.userData.isLogin ?
                            details !== undefined &&
                            <section id="breadcrumbs" className="py-6 bg-gray-50">
                                <div className="container mx-auto px-4 text-xs md:text-base">
                                    <div className="grid grid-cols-1">
                                        <div>
                                            <span className="font-bold">{Helpers.translation('code')}: </span>
                                            <span>{details.code}</span>
                                        </div>

                                        <div>
                                            <span className="font-bold">{Helpers.translation('quantity')}: </span>
                                            <span>{details.quantity}</span>
                                        </div>

                                        <div>
                                            <span className="font-bold">{Helpers.translation('currency')}: </span>
                                            <span>{details.currency.data.attributes.title}</span>
                                        </div>

                                        <div>
                                            <span className="font-bold">{Helpers.translation('account_number')}: </span>
                                            <span>{details.account_number.data.attributes.title}</span>
                                        </div>

                                        <div>
                                            <span className="font-bold">{Helpers.translation('payment_date')}: </span>
                                            <span>{Helpers.explodeDate(details.payment_date).date}</span>
                                        </div>

                                        <div>
                                            <span className="font-bold">{Helpers.translation('status')}: </span>
                                            <span>{Helpers.translation(details.status)}</span>
                                        </div>
                                    </div>

                                    {
                                        details.receipts.data !== null &&
                                        <>
                                            <div className="font-bold text-xl mt-4 mb-1">{Helpers.translation('receipts')}</div>
                                            <div className="grid grid-cols-1 mt-2">
                                                {
                                                    details.receipts.data !== null &&
                                                    details.receipts.data.map((receipt: any, index: number) => {
                                                        return (
                                                            <div key={index}>
                                                                <Link
                                                                    className="text-primary"
                                                                    to={Helpers.getBiggestImageUrl(receipt.attributes)}
                                                                    target="_blank"
                                                                >
                                                                    {receipt.attributes.name}
                                                                </Link>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    const { id } = useParams();

    props = {
        ...props,
        id
    }

    return <PaymentNotificationDetails {...props} navigate={navigate} />
}

export default WithNavigate